<div class="edit">
  <fa-icon [icon]="faPen" [routerLink]="['/cameras/update']"
    [queryParams]="{name: data.camera.name,id: data.camera.id }" routerLinkActive="router-link-active"
    (click)="dialogRef.close()">
  </fa-icon>
</div>
<div class="wrap">
  <div class="content">
    <h3>Camera setup </h3>
    <h2>{{data.camera.name}}</h2>
    <ul>
      <li>Mod: <strong>{{configCamera?.mode}}</strong></li>
      <li>Reset: <strong>{{configCamera?.reset}}</strong></li>
    </ul>
    <button (click)="dialogRef.close()">Close</button>
  </div>
</div>